import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import toast from 'shared/utils/toast';
import TransportActiveDocumentForm from '../../TransportActiveDocument/components/form/TransportActiveDocumentForm';
import { ITransportActiveDocument } from '../../types';
import { supplierTransportActiveDocumentService } from '../api/supplier-transport-active-document.service';

const initDdt: ITransportActiveDocument = {
  id: null,
  ref: '',
  status: null
};

export const CreateSupplierTransportActiveDocument = () => {
  const translationPrefix = 'pages.supplier-active-ddt.new';

  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    supplierTransportActiveDocumentService
      .add({ ...values, warehouse_out: values.warehouse_out['id'], order: values.order }) // warehouse_out is a IWarehouse object, we need to get only PK
      .then((res) => {
        if (res?.id) {
          if ('warnings' in res && Array.isArray(res.warnings)) {
            res.warnings.forEach((warning) => {
              toast.warning(warning);
            });
          } else {
            toast.success(t(`${translationPrefix}.success`));
          }
          navigate(`../${res.id}`);
        }
      });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <TransportActiveDocumentForm
        transport_document={initDdt}
        onSubmit={onSubmit}
        isUpdate={false}
        isSupplierDdt={true}
      />
    </TenantPage>
  );
};

export default CreateSupplierTransportActiveDocument;
